module.exports = __webpack_public_path__ + "img/instagram.b51354cf.png";